module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.631965f9.ttf";